import { InstallClientOverview } from "@/pages";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/_layout/_main/_centered/install-client/",
)({
  component: InstallClientOverview,
});
